import React from 'react';
import { Space, Title, Text, Checkbox } from 'components';
import { INotificationSettings } from '@bb/domain/dist/types';

type DailyRecapsProps = {
  dailySettings: Pick<
    INotificationSettings,
    'dailyOpenHouse' | 'dailyNewListings' | 'dailyNeeds'
  >;
  setModifiedNotifications: React.Dispatch<
    React.SetStateAction<INotificationSettings>
  >;
};

const DailyRecaps: React.FC<DailyRecapsProps> = ({
  dailySettings,
  setModifiedNotifications,
}) => {
  const fieldsMap: [keyof typeof dailySettings, string][] = [
    ['dailyOpenHouse', 'Open Houses'],
    ['dailyNewListings', 'New Listings'],
    ['dailyNeeds', 'Haves & Wants'],
  ];

  return (
    <Space direction="vertical" size={'large'}>
      <Space direction="vertical">
        <Title level={3}>Daily Recaps</Title>

        <Text>
          You can choose to be notified daily of new open houses, listings, and
          haves / wants:
        </Text>
      </Space>
      <Space direction="vertical">
        {fieldsMap.map(([field, label], index) => (
          <Checkbox
            key={index}
            data-cy={`daily-recap-${field}`}
            checked={dailySettings[field]}
            onChange={({ target: { checked } }) =>
              setModifiedNotifications(prev => ({
                ...prev,
                [field]: checked,
              }))
            }
          >
            {label}
          </Checkbox>
        ))}
      </Space>
    </Space>
  );
};

export default DailyRecaps;
